import { useEffect } from 'react';

import pillSection from 'public/pill-section.svg';
import pillTriangle from 'public/pill-triangle.svg';
import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import Spinner from 'src/app/components/Elements/Spinner';
import { useSegmentTrack } from 'src/app/hooks/useSegmentTrack';
import { loggedOutShowYourDoctor } from 'src/app/router/paths';
import { getCurrentPathname } from 'src/app/state/selectors';
import { useSelector } from 'src/app/state/store';

import { ContactSection, Header, ShareButton, ToolTipSection } from './Sections';
import { PillSectionSVG, PillTriangleSVG, ShowYourDoctorSection } from './styles';

export const ShowYourDoctor = ({ facility, pagepath, segmentTrack, isLoggedIn, redirectToShowYourDoctor }) => {
  useSegmentTrack(UNIFIED.viewShowYourDoctor);
  const currentPath = useSelector(getCurrentPathname);
  useEffect(() => {
    if (isLoggedIn && currentPath === loggedOutShowYourDoctor.toPath()) {
      redirectToShowYourDoctor();
    }
  }, [isLoggedIn, redirectToShowYourDoctor, currentPath]);

  if (facility?.isFetching) return <Spinner centered />;

  // Passing the logged in state to the container to account for padding difference between layouts
  return (
    <ShowYourDoctorSection isLoggedIn={isLoggedIn}>
      <PillTriangleSVG src={pillTriangle} />
      <PillSectionSVG src={pillSection} />
      <Header />
      <ContactSection facility={facility} />
      <ToolTipSection />
      <ShareButton facility={facility} segmentTrack={segmentTrack} pagepath={pagepath} />
    </ShowYourDoctorSection>
  );
};
